const TextData = {
    AnalysisData: {
        equivalentCards: [{
            title: `Trees' absorption capacity`,
            imgTxt: ` 🌲 40`,
            intro: `Equivalent to planting 40 trees and letting them grow for 10 years.
    Reducing carbon emissions' impact on the environment is like increasing a large amount of vegetation. 🌍💚`
        }, {
            title: `Vehicle emission reduction`,
            imgTxt: ` 🚗🌬️ 2,796miles`,
            intro: `Equivalent to driving a car 4,500 kilometers (2,796 miles) less.
    Reducing carbon emissions helps alleviate traffic congestion and improve air quality. 🌁🍃`
        }, {
            title: `Energy consumption`,
            imgTxt: ` ⚡ 1,550kwh`,
            intro: `Equivalent to saving 1,550 kwhof electricity consumption.
    Reducing carbon emissions leads to a reduction in energy consumption and lowering electricity costs. 💸💚`
        }, {
            title: `Relation to Glacier Melting`,
            imgTxt: `🧊  3m³`,
            intro: `Reducing 1 ton of carbon emissions prevents approx. 3 m³ of polar ice from melting.
    Helps combat global climate change and sea level rise.`
        }, {
            title: `Water Resource Savings`,
            imgTxt: `💧  3,000L`,
            intro: `Lower carbon emissions help reduce water consumption.
    Reducing 1 ton of carbon emissions saves around 3,000 L of water.`
        }, {
            title: `Waste Reduction in Landfills `,
            imgTxt: ` 🗑️  5.5m³`,
            intro: `Reducing 1 ton of carbon emissions equals a decrease of 5.5 cubic meters of landfill space.`
        }],

        reduceCards: [{
            titleTag: ``,
            title: `⚡ Reduce peak-hour electricity usage `,
            txt: `To decrease carbon emissions, reduce electricity usage during peak hours when electricity providers increase their supply. Opt for natural ventilation and sunlight during hot daytime hours or use high-efficiency electric appliances.<span>We have noticed that your electricity usage tends to be higher at 6 pm every day, so reducing usage during this peak hour can help lower your carbon footprint and energy bill.</span>`,
            bkColor: '#f6fdff'
        }, {
            titleTag: `↓5500 kg CO2`,
            title: `☀️ Use solar power `,
            txt: `Installing solar panels can help households generate their own clean energy and reduce their reliance on fossil fuels, which can reduce up to <span>5,500 kg of CO2 </span> emissions per year in an average Texas household. Incentive programs are also available to make solar panel installation more affordable, providing long-term savings on electricity bills.`,
            bkColor: '#fffef9'
        }, {
            titleTag: `↓1500 kg C02`,
            title: `🌞 Use energy-efficient appliances`,
            txt: `Home appliances that are energy-efficient can help reduce carbon emissions and save money on energy bills. Such appliances consume less energy when in operation, and require less energy to manufacture thanks to efficient designs and use of advanced materials. By using energy-efficient refrigerators and washing machines 🌊, an average Texas household can reduce up to <span>1500 kg of CO2 </span> emissions per year.`,
            bkColor: '#fcfbfb'
        }, {
            titleTag: `↓170 kg CO2`,
            title: `💡 Use LED light bulbs `,
            txt: `Traditional incandescent light bulbs consume more energy to produce the same amount of light as LED bulbs. Switching to LED bulbs can significantly reduce energy consumption, with a single LED bulb lasting up to 25 times longer than traditional bulbs. By replacing just five incandescent bulbs with LED bulbs, an average Texas household can reduce up to <span>170 kg of CO2 </span> emissions per year.`,
            bkColor: '#fffef9'
        }, {
            titleTag: `↓-90.36%`,
            title: `💯 Use 100% green energy`,
            txt: `Avoided <span>9.37</span> tons of CO2 per year🌍 which would taken <span>84.4</span>. trees🌲 one year to absorb 🌳❤️.We're committed to continuing our eco-friendly practices and making a meaningful difference for future generations 💪`,
            bkColor: '#f9fef7'
        }, {
            titleTag: `↓288 kg C02`,
            title: `💧 Reduce water usage`,
            txt: `Conserving water is crucial because water treatment and distribution are energy-consuming. By installing low-flow showerheads and faucets and repairing any leaks, an average Texas household can reduce its water consumption by <span>40% </span> 🚿 and save up to <span>288 kg of CO2 </span> emissions per year. This simple measure can also help reduce water bills and save money in the long run.`,
            bkColor: '#f6fdff'
        }, {
            titleTag: `↓840 kg CO2`,
            title: `❄️🌞 Set thermostat temperatures `,
            txt: `Reducing thermostat temperatures in winter and raising them during summer can help save energy and money. Lowering heating temperatures by just 2°C during winter and increasing cooling by the same amount in summer can save up to <span>10% 💰 on energy costs</span>. By following these simple steps, an average Texas household can reduce up to <span>840 kg of CO2</span> emissions each year.`,
            bkColor: '#f6fdff'
        }, {
            titleTag: `↓160 kg CO2`,
            title: `🖥️ Turn off standby devices`,
            txt: `Many electrical appliances continue to consume energy when not in use due to standby mode, an energy-saving feature that keeps devices running to maintain the current state. Unplugging appliances can help save power and decrease carbon emissions. By actively unplugging devices instead of leaving them in standby mode, an average Texas household can reduce up to <span>160 kg of CO2</span> emissions per year. 🌱👍`,
            bkColor: '#fcfbfb'
        }, {
            titleTag: `↓600 kg CO2`,
            title: `🌳 Plant trees `,
            txt: `Trees absorb carbon dioxide (CO2) from the air and store it in their trunk, branches, and leaves. An average household in Texas can reduce up to <span>600 kg of CO2</span> emissions per year by planting just 5 trees. Trees not only help reduce carbon emissions, but they also provide shade and help keep homes cool in the summer.`,
            bkColor: '#f9fef7'
        }]
    }
}

export default TextData;